/**
 * Created by LittleRedHat on 2016/7/12.
 */
var start_param = {
    limit: 6
};
var second_subject_loadFinish = {};
/*
 我要提问规则
 */
var addQuestionRule = {
    question_title: {
        rules: [
            {
                type: 'empty',
                prompt: '请填写问题标题'
            }
        ]

    },
    question_content: {
        rules: [
            {
                type: 'empty',
                prompt: "请填写问题内容"
            }
        ]
    }
};

$(document).ready(function () {
    var symbol = getUrlParam('symbol');
    if (!symbol) {
        window.location.href = "404.html";
    }
    var second_subject = 'all';
    /*
     tab initialization,it is complex since you need to init properly or you will find you will get the same item
     and you must disable callbacks when one scroll callback is in running and you must not share variable data with different
     tab since it will introduce race condition
     */
    $('.start-recommend-tab').one('click', function (event) {
        // for tab initialization so it will prevent all next click handler
        event.stopImmediatePropagation();
        var tab = $(this).attr('data-tab');
        if (tab == 'topic-recommend') {
            $('#topic-recommend').visibility({
                once: false,
                // update size when new content loads
                observeChanges: true,
                // load content on bottom edge visible
                onBottomVisible: function () {
                    $('#topic-recommend').visibility('disable callbacks');
                    //console.log('disable callbacks');
                    $('#topic-loader').css({
                        'visibility': 'visible'
                    });
                    var start = $(this).children('.start-recommend-item').length;
                    var promise = getTopicRecommend(start, start_param.limit, symbol);

                    promise
                        .done(function (data) {
                            if (data.basebooks.length > 0) {
                                $('#topic-recommend').visibility('enable callbacks');
                                //console.log('enable callbacks');
                            }else{
                                $('#topic-recommend').visibility('disable callbacks');

                            }
                            $('#topic-loader').css({
                                'visibility': 'hidden'
                            });
                        })
                        .fail(function (data) {
                            $('#topic-recommend').visibility('enable callbacks');
                            $('#topic-loader').css({
                                'visibility': 'hidden'
                            });


                        })
                }
            });
        } else {
            var promise = getSecondSubject(symbol);
            promise.done(function (data) {
                $('#second-subjects a.second-subject').one('click', function (event) {
                    event.stopImmediatePropagation();
                    var second_subject = $(this).data('symbol');
                    var $recommend = $('#' + second_subject + '_recommend');
                    $recommend.siblings('.second_subject_recommend').hide();
                    $recommend.css('display', 'block');
                    $(this).addClass("active")
                        .siblings().removeClass("active");

                    $recommend.visibility({
                        once: false,
                        // update size when new content loads
                        observeChanges: true,
                        // load content on bottom edge visible
                        onBottomVisible: function () {
                            $recommend.visibility('disable callbacks');
                            $('#subject-loader').css({
                                'visibility': 'visible'
                            });
                            var start = $recommend.children('.start-recommend-item').length;
                            var promise2 = getSecondSubjectRecommend(start, start_param.limit, symbol,second_subject);
                            promise2
                                .done(function (data) {
                                    if (data.basebooks.length > 0) {
                                        $recommend.visibility('enable callbacks');
                                    }else{
                                        $recommend.visibility('disable callbacks');

                                    }
                                    $('#subject-loader').css({
                                        'visibility': 'hidden'
                                    });
                                })
                                .fail(function(data){
                                    $recommend.visibility('enable callbacks');
                                    $('#subject-loader').css({
                                        'visibility': 'hidden'
                                    });

                                });
                        }
                    });
                }).on('click', function (event) {
                    $(this).addClass("active")
                        .siblings().removeClass("active");
                    second_subject = $(this).data("symbol");
                    // //console.log(second_subject);
                    var second_subject_id = second_subject + '_recommend';
                    var $recommend = $('#' + second_subject_id);
                    $recommend.siblings('.second_subject_recommend').hide();
                    $recommend.css('display', 'block');


                });
                $('#second-subjects a.second-subject[data-symbol=all]').trigger('click');
            });
        }
    });
    $('.start-recommend-tab[data-tab=subject-recommend]').trigger('click');
    /*
     get slider
     */
    getStartSlider(0, 4, symbol);
    /*
     get latest-recommend
     */
    getLatestRecommend(0, 10, symbol);
    /*
     get hot-recommend
     */
    getHotRecommend(0, 10, symbol);

    $('#ask-question-modal').form({
        keyboardShortcuts:false,
        fields: addQuestionRule,
        inline: true,
        on: 'submit'
    });
    /*
     hover item事件委派处理
     */
    $('#subject-recommend,#topic-recommend').on('mouseenter', '.start-recommend-item', function (event) {
        var share = $(this).find('.share-wrapper');
        share.find('.share').share();
        share.show();
        var actions = $(this).find('.meta.recommend-meta a.action');
        actions.show();
    }).on('mouseleave', '.start-recommend-item', function (event) {
        var share = $(this).find('.share-wrapper');
        share.hide();
        var actions = $(this).find('.meta.recommend-meta a.action');
        actions.hide();
    }).on('click','.item .meta a.collect',function(event){
            var basebook_id = $(this).closest('.item').data('id');
            //console.log(basebook_id);
            addCollect(basebook_id);
        }).on('click','.meta a.question',function(event){
            var basebook_id = $(this).closest('.item').data('id');
            show_question_modal(basebook_id);
        });
    $('#ask-question-modal').on('click','.question',function(event){
        submitQuestion();
    });
});

function getSecondSubject(subject) {
    var promise = secondSubjects(subject);
    promise
        .done(function (data) {
            if (data.sub_subjects.length >= 5) {
                data.more = true;
            }
            $('#second-subjects').html(S['templates']['second_subject'](data));
        })
        .done(function (data) {
            /*
             动态创建子学科对应的分页
             */
            second_subject_loadFinish['all'] = false;
            var innerHtml = S['templates']['second_subject_recommend_container']({
                second_subject: 'all'
            });
            $.each(data.sub_subjects, function (index, value) {
                innerHtml += S['templates']['second_subject_recommend_container']({
                    second_subject: value['symbol']
                });
                second_subject_loadFinish[value['symbol']] = false;
            });
            $(innerHtml).insertBefore($('#subject-loader'));
        });
    return promise;
}
function getStartSlider(start, limit, subject) {
    var promise = startSlider(start, limit, subject);
    promise.done(function (data) {
        $('#slider').html(S['templates']['start_slider'](data));
        $('#slider').nivoSlider({});

    });
}
function getHotRecommend(start, limit, subject) {
    var promise = hotRecommend(start, limit, subject);
    promise.done(function (data) {
        $('#hot-recommend').html(S['templates']['latest_recommend'](data));

    });
}
function getLatestRecommend(start, limit, subject) {
    var promise = latestRecommend(start, limit, subject);
    promise.done(function (data) {
        $('#lastest-recommend').html(S['templates']['latest_recommend'](data));
        $('#lastest-recommend .share').share();
    });
}
function getSecondSubjectRecommend(start, limit, subject, second_subject) {
    var promise = secondSubjectRecommend(start, limit, subject, second_subject);
    promise
        .done(function (data) {
            var $recommend = $('#' + second_subject + '_recommend');
            var $items = S['templates']['start_recommend'](data);
            $recommend.append($items);


        });

    return promise;
}
function getTopicRecommend(start, limit, subject) {
    var promise = topicRecommend(start, limit, subject);
    promise
        .done(function (data) {
            $(S['templates']['start_recommend'](data)).insertBefore($('#topic-loader'));

        });
    return promise;



}
function addCollect(basebook_id) {
    if (!sessionStorage.getItem("user")) {
        $('.login-modal').modal('show');
        return;
    }
    //select_basebook = basebook_id;
    var promise = collectPost(basebook_id);
    promise.done(function (data) {
        if (data.status != 0) {
            $('#warning').find('.content').text(data.message);
            $('#warning').modal('show');
        } else {
            $('#warning').find('.content').text("收藏成功");
            $('#warning').modal('show');

        }
    });
}
function show_question_modal(basebook_id) {
    if (!sessionStorage.getItem("user")) {
        $('.login-modal').modal('show');
    } else {
        $('#ask-question-modal').data('basebook_id',basebook_id);
        $('#ask-question-modal').modal('show');
    }
}
function submitQuestion() {
    var basebook_id = $('#ask-question-modal').data('id');
    var valid = $('#ask-question-modal').form('is valid', addQuestionRule);
    if (valid) {
        var title = $('#ask-question-modal input[name=question_title]').val();
        var content = $('#ask-question-modal textarea[name=question_content]').val();
        var promise = questionPost(title, content,  basebook_id);
        promise.done(function (data) {
            $('#ask-question-modal').modal('hide');
        });
        return;
    }
}
//如果必要,子学科标签的展开和收起
function displaymoresubjects() {
    if ($('.more-types:eq(0)').is(":hidden")) {
        $('.less-types:eq(0)').hide();
        $('.more-types:eq(0)').show();
        $('.second-subjects:eq(0)').css({overflow: "hidden"})
            .animate({height: "70px"}, 400);
    } else {
        $('.more-types:eq(0)').hide();
        $('.less-types:eq(0)').show();
        $('.second-subjects:eq(0)').css({overflow: "visible"})
            .animate({height: "135px"}, 400);
    }
}

/*
 fetch/post data api ,return promise for reuse
 */
function secondSubjects(subject) {
    return $.ajax(
        {
            url: server_base + '/subject/get/' + subject,
            method: 'GET',
            dataType: 'json'
        });

}
function secondSubjectRecommend(start, limit, subject, secondSubject) {
    var url = "";
    if (secondSubject == 'all') {
        url = server_base + '/basebook/get/symbol/' + subject;
    } else {
        url = server_base + '/basebook/get/symbol/' + subject + '/' + secondSubject;
    }
    return $.ajax({
        url: url,
        method: 'GET',
        dataType: 'json',
        //xhrFields: {withCredentials: true},
        ////crossDomain: true,
        data: {
            type: 'subject',
            start: start,
            limit: limit
        }
    });
}
function topicRecommend(start, limit, subject) {
    return $.ajax({
        url: server_base + '/basebook/get/symbol/' + subject,
        method: 'GET',
        dataType: 'json',
        //xhrFields: {withCredentials: true},
        ////crossDomain: true,
        data: {
            type: 'topic',
            start: start,
            limit: limit
        }
    });
}
function startSlider(start, limit, subject) {
    return $.ajax({
        url: server_base + '/basebook/get/symbol/' + subject,
        method: 'GET',
        dataType: 'json',
        data: {
            type: 'hot',
            start: start,
            limit: limit
        },
        //xhrFields: {withCredentials: true},
        ////crossDomain: true
    });
}
function hotRecommend(start, limit, subject) {
    return $.ajax({
        url: server_base + '/basebook/get/symbol/' + subject,
        method: 'GET',
        dataType: 'json',
        data: {
            type: 'hot',
            start: start,
            limit: limit
        },
        //xhrFields: {withCredentials: true},
        ////crossDomain: true
    });
}
function latestRecommend(start, limit, subject) {
    return $.ajax({
        url: server_base + '/basebook/get/symbol/' + subject,
        method: 'GET',
        dataType: 'json',
        data: {
            type: 'new',
            start: start,
            limit: limit
        },
        //xhrFields: {withCredentials: true},
        ////crossDomain: true
    });
}
function questionPost(title, content, basebook) {
    return $.ajax({
        url: server_base + '/basebook/ask/' + basebook,
        method: "POST",
        data: {
            title: title,
            content: content
        },
        dataType: 'json',
        //xhrFields: {withCredentials: true},
        ////crossDomain: true
    });
}
function collectPost(basebook) {
    return $.ajax({
        url: server_base + '/basebook/star/' + basebook,
        method: 'POST',
        dataType: 'json',
        //xhrFields: {withCredentials: true},
        ////crossDomain: true
    });


}
/*
 fetch/post data end
 */
